// extracted by mini-css-extract-plugin
export default {"component":"panel_component__tqV85","prize":"panel_prize__L2zpD","button":"panel_button__ri041"};